import { render } from "./VehicleItemBidStatus.vue?vue&type=template&id=64a3ba8d"
import script from "./VehicleItemBidStatus.vue?vue&type=script&lang=js"
export * from "./VehicleItemBidStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__